import styled, { css, keyframes } from 'styled-components';

/* O coração cresce e assenta: o exagero no meio é o que dá a sensação de
   resposta ao clique. */
const pop = keyframes`
  0% {
    transform: scale(1);
  }
  35% {
    transform: scale(1.35);
  }
  70% {
    transform: scale(0.92);
  }
  100% {
    transform: scale(1);
  }
`;

/* Anel rosa que sai da borda do botão e se dissolve. */
const ring = keyframes`
  0% {
    opacity: 0.6;
    transform: scale(0.65);
  }
  100% {
    opacity: 0;
    transform: scale(2.1);
  }
`;

const Container = styled.button`
  position: relative;
  width: ${({ size }) => (size === 'md' ? '4.2rem' : '3.2rem')};
  height: ${({ size }) => (size === 'md' ? '4.2rem' : '3.2rem')};
  padding: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: var(--surface);
  border: 1px solid var(--border);
  color: ${({ active }) => (active ? 'var(--rosa)' : 'var(--ink-soft)')};
  box-shadow: var(--shadow-sm);
  transition: color var(--dur-fast) var(--ease-standard),
    transform var(--dur-fast) var(--ease-standard),
    border-color var(--dur-fast) var(--ease-standard);

  :hover {
    transform: scale(1.08);
    color: var(--rosa);
    border-color: var(--border-strong);
  }

  /* A animação fica no ícone, não no botão, para não brigar com o scale
     do :hover. */
  svg {
    ${({ burst }) =>
      burst &&
      css`
        animation: ${pop} 0.4s var(--ease-out);
      `}
  }

  ::after {
    content: '';
    position: absolute;
    inset: -1px;
    border-radius: 50%;
    border: 2px solid var(--rosa);
    opacity: 0;
    pointer-events: none;
    ${({ burst }) =>
      burst &&
      css`
        animation: ${ring} 0.5s var(--ease-out);
      `}
  }
`;

export default Container;
